<div class="row">
    <div class="col-12 ml-auto mr-auto">
        <div class="dash-card">
            <!-- <app-back-button [defaultRoute]="getBackLink()"
                [useDefaultRoute]="true" [step]="9"></app-back-button> -->

            <ng-container *ngIf="loading">

                <div class="dash-card-header">
                    <ngx-skeleton-loader
                        [theme]="{width: '111px',height: '27px'}">
                    </ngx-skeleton-loader>
                </div>

                <div class="dash-card-body">
                    <div class="row">

                        <div class="col-12">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-3">
                            <ngx-skeleton-loader
                                [theme]="{height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader
                                [theme]="{width: '165px',height: '44px',marginBottom:'24px'}">
                            </ngx-skeleton-loader>
                        </div>

                        <div class="col-12">
                            <ngx-skeleton-loader [theme]="{height: '500px'}">
                            </ngx-skeleton-loader>
                        </div>


                        <div class="col-12">

                            <ngx-skeleton-loader
                                [theme]="{width: '200px',height: '40px'}">
                            </ngx-skeleton-loader>

                            <div class="row">
                                <div class="col-12"
                                    *ngFor="let number of [0,1,2,3,4,5]">
                                    <ngx-skeleton-loader
                                        [theme]="{width: '100%',height: '25px'}">
                                    </ngx-skeleton-loader>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="row">
                        <div
                            class="col-12 text-right d-flex align-items-center justify-content-end">
                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px',marginRight: '16px'}">
                            </ngx-skeleton-loader>

                            <ngx-skeleton-loader
                                [theme]="{width: '130px',height: '40px'}">
                            </ngx-skeleton-loader>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading">
                <div class="dash-card-header">
                    <h2 *ngIf="!id"><span>Criar template minuta</span></h2>

                    <h2 *ngIf="id">Editar template minuta <span>{{title}}</span>
                    </h2>

                    <div class="d-flex align-items-center justify-content-end"
                        *ngIf="!showForm && !showResume">
                        <app-button (onClick)="showLineModal()"
                            class="add-button">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Adicionar linha de assinatura
                        </app-button>
                    </div>


                </div>

                <div class="dash-card-body">
                    <div class="row mb-5" *ngIf="showResume">
                        <div class="col-lg-4">
                            <p class="title">
                                Nome da minuta
                            </p>
                            <p class="label">
                                {{form.controls.name.value || '-'}}
                            </p>
                        </div>

                        <div class="col-lg-4">
                            <p class="title">
                                Tipo de documento
                            </p>
                            <p class="label">
                                {{renderType(form.controls.type.value)}}
                            </p>
                        </div>

                        <div class="col-lg-4">
                            <p class="title">
                                Validade
                            </p>
                            <p class="label">
                                {{form.controls.final_date.value || '-'}}
                            </p>
                        </div>
                    </div>

                    <form [formGroup]="form">
                        <div class="row" *ngIf="showForm">
                            <div class="col-12 col-lg-4">
                                <app-input [group]="form" controlName="name"
                                    label="Nome da minuta" placeholder="Digite">
                                </app-input>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-select [items]="typeItems" [group]="form"
                                    controlName="type" label="Tipo de minuta"
                                    placeholder="Selecione">
                                </app-select>
                                <app-spacer [bottom]="24"></app-spacer>
                            </div>

                            <div class="col-12 col-lg-4">
                                <app-masked-input [group]="form"
                                    controlName="final_date" mask="00/00/0000"
                                    label="Validade" placeholder="dd/mm/aaaa">
                                </app-masked-input>

                                <app-spacer [bottom]="24"></app-spacer>
                            </div>
                        </div>


                        <div class="row">
                            <div [class.d-none]="loading" class="w-100">
                                <quill-editor [modules]="quillModules"
                                    class="editor-container"
                                    formControlName="content">
                                </quill-editor>
                            </div>

                        </div>

                        <app-spacer [bottom]="32"></app-spacer>

                        <ng-container *ngIf="showForm">
                            <h6 class="mb-3 pl-2">Variáveis disponíveis</h6>
                            <p class="mb-3 pl-2 text-muted">
                                Clique nas variáveis para inserir no texto.
                            </p>

                            <form [formGroup]="searchForm">
                                <app-input [group]="searchForm"
                                    controlName="search">
                                </app-input>
                            </form>

                            <table class="bordered">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Variável</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let item of variables">
                                        <td>
                                            {{item.name}}
                                        </td>
                                        <td>
                                            <div class="tag"
                                                [class.smart]="item.type === 'fs_engine'"
                                                (click)="insertVariable(item.variable)"
                                                style="cursor: pointer;">
                                                {{item.variable}}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="dash-card-pagination">
                                <app-pagination [data]="variables"
                                    [count]="count" [show]="!loading"
                                    [offset]="offset"
                                    (onPageChange)="changePageData($event)"
                                    [dashPagination]="true"
                                    [resultsPerPage]="results_per_page">
                                </app-pagination>
                            </div>
                        </ng-container>


                        <ng-container *ngIf="showResume">
                            <h6 class="mb-3 pl-2">Assinantes</h6>
                            <table class="bordered"
                                *ngIf="assignees.length > 0">
                                <thead>
                                    <tr>
                                        <th>Papel</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        *ngFor="let item of assignees; let i = index">
                                        <td>
                                            {{item.label}}
                                        </td>
                                        <td
                                            style="width: 50px; text-align: center;">
                                            <button class="dash-item-button"
                                                (click)="removeAssignee(i)">
                                                <svg-icon
                                                    src="assets/images/icon-trash.svg"></svg-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div *ngIf="assignees.length === 0"
                                class="text-center py-4">
                                <p class="text-muted">Nenhum assinante
                                    adicionado</p>
                            </div>
                        </ng-container>

                        <app-spacer [bottom]="48"></app-spacer>

                        <div class="row">
                            <div class="col-12  d-flex justify-content-between">
                                <app-button (onClick)="redirect()"
                                    class="add-button" [outline]="true">
                                    Cancelar
                                </app-button>

                                <div class="d-flex align-items-center">
                                    <app-button (onClick)="handleBack()"
                                        class="add-button" [outline]="true">
                                        Voltar
                                    </app-button>
                                    <app-spacer [right]="16"></app-spacer>

                                    <app-button (onClick)="createTemplate(true)"
                                        class="add-button" [outline]="true"
                                        [disabled]="getDisabled()">
                                        Salvar rascunho
                                    </app-button>
                                    <app-spacer [right]="16"></app-spacer>

                                    <app-button (onClick)="handleNext()"
                                        [disabled]="getDisabled()"
                                        class="add-button">
                                        {{showResume ? 'Salvar modelo' :
                                        'Avançar' }}
                                    </app-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<app-warning-modal [active]="lineModal" (onClose)="lineModal = false">
    <h3>Adicionar linha de assinatura</h3>
    <app-spacer [bottom]="24"></app-spacer>
    <form [formGroup]="lineForm">
        <div class="row">
            <div class="col-12">
                <app-select [items]="visibleRoles" [multiple]="true"
                    [group]="lineForm" controlName="role" label="Papel"
                    placeholder="Selecione o papel"
                    [helpText]="visibleRoles.length === 0 ? 'Todos os papéis já foram adicionados' : ''">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>
    </form>

    <app-spacer [bottom]="56"></app-spacer>

    <app-button (onClick)="lineModal = false" [center]="true" [danger]="true">
        Cancelar
    </app-button>
    <app-spacer [bottom]="8"></app-spacer>
    <app-button (onClick)="addAssignees()" [center]="true" class="add-button"
        [disabled]="!lineForm.controls.role.value || lineForm.controls.role.value.length === 0 || visibleRoles.length === 0">
        Adicionar linha de assinatura
    </app-button>
</app-warning-modal>